import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { BehaviorSubject, Observable } from 'rxjs';
import { DynamicEntryComponentCrmConfig, DynamicOptionsComponent } from '../dynamic-options';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-text-tag-input',
  templateUrl: './free-text-list-input.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatChipsModule,
  ],
})
export class FreeTextListInputComponent implements OnInit, DynamicOptionsComponent {
  @ViewChild('chipList') chipList;

  private textValues: string[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  @Input() initialValue: string[];
  @Input() showVariableItemMenu: boolean;
  @Input() label = 'AUTOMATIONS.EDITOR.FILTERS.CUSTOM_DATA.DATA_LABELS.FREE_TEXT_LIST';
  @Input() config: DynamicEntryComponentCrmConfig;
  selectedValue$$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  selectedValue$: Observable<any> = this.selectedValue$$.asObservable();

  constructor(private readonly ref: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (
      this.initialValue !== null &&
      this.initialValue !== undefined &&
      this.initialValue.length > 0 &&
      Array.isArray(this.initialValue)
    ) {
      this.textValues = this.initialValue;
    } else {
      this.textValues = [];
    }
    this.selectedValue$$.next(this.textValues);
  }

  private setErrorState(): void {
    this.chipList.errorState = this.textValues?.length < 1;
    this.ref.detectChanges();
  }

  remove(text: string): void {
    this.textValues = this.textValues?.filter((v) => v !== text);
    this.selectedValue$$.next(this.textValues);
    this.setErrorState();
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (!value || this.textValues?.findIndex((e) => e === value) !== -1) {
      return;
    }

    this.textValues.push(value);
    this.selectedValue$$.next(this.textValues);
    this.setErrorState();
    event.chipInput?.clear();
  }

  getSelectedValue(): string[] {
    return this.textValues;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    this.setErrorState();
    return [];
  }

  isFormValid(): boolean {
    return this.textValues.length > 0;
  }
}
